import { useState } from "react";
import { useParams } from "react-router-dom";
import { isNull } from "lodash";
import useLzFApiCall from "@lz-services/Api";
import { useLzOnMount } from "@lz-services/Hooks";
import { lzFGetFormattedDate } from "@lz-services/Moment";
import LzXSpinner from "@lz-components/commons/Spinner";
import LzXPrint from "@lz-components/commons/Print";
import { getFormattedAmount } from "services/Utils";

const SummaryOfSalesInvoicesPrint = () => {
    const routeParams = useParams();
    const [summary, setSummary] = useState(null);
    const [records, setRecords] = useState(null);
    const apiCall = useLzFApiCall();

    const load = async () => {
        setRecords(null);
        const data = await apiCall('reports/summary-of-sales-invoices', routeParams);
        if (data && data.summary && data.records) {
            setSummary(data.summary);
            setRecords(data.records);
        }
    };

    // Call only for the first time when component is initially loaded
    useLzOnMount(() => {
        load();
    });

    if (isNull(summary) || isNull(records)) {
        return <LzXSpinner />;
    }

    return (
        <LzXPrint onReload={load} className="report-print" printInLandscape>

            <table cellPadding={8} cellSpacing={0} className="report-table">
                <thead>
                    <tr>
                        <th colSpan={11}>
                            <header>
                                <h1>GRIND WHEEL (PAK) LTD.</h1>
                                <h2>Summary of Sales Invoices</h2>
                                <h2>From {lzFGetFormattedDate(routeParams.start_date)} to {lzFGetFormattedDate(routeParams.end_date)}</h2>

                                <div style={{ textAlign: 'left' }}>
                                    <b>Printing Date: </b>
                                    {lzFGetFormattedDate()}
                                </div>
                            </header>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>S.Tax Inv #</th>
                        <th>Invoice Date</th>
                        <th>Invoice No.</th>
                        <th>Gross</th>
                        <th>Discount</th>
                        <th>Discounted</th>
                        <th>Sales Tax</th>
                        <th>Further Tax</th>
                        <th>WHT</th>
                        <th>Invoice Value</th>
                        <th>FBR Invoice No.</th>
                    </tr>
                    {records.map((rec, rdex) =>
                        <tr key={'rec-' + rdex}>
                            <td>{rec.sales_tax_invoice_no}</td>
                            <td>{lzFGetFormattedDate(rec.invoice_date)}</td>
                            <td>{rec.invoice_no}</td>
                            <td className="money">{getFormattedAmount(rec.gross_value, true)}</td>
                            <td className="money">{getFormattedAmount(rec.discount_value, true)}</td>
                            <td className="money">{getFormattedAmount(rec.discounted_value, true)}</td>
                            <td className="money">{getFormattedAmount(rec.sales_tax, true)}</td>
                            <td className="money">{getFormattedAmount(rec.further_tax, true)}</td>
                            <td className="money">{getFormattedAmount(rec.wht, true)}</td>
                            <td className="money">{getFormattedAmount(rec.invoice_value, true)}</td>
                            <td>{rec.fbr_invoice_no || '-'}</td>
                        </tr>
                    )}
                    <tr style={{ fontWeight: 'bold', textAlign: 'right' }}>
                        <td colspan={3}>Totals:</td>
                        <td>{getFormattedAmount(summary.gross_value, true)}</td>
                        <td>{getFormattedAmount(summary.discount_value, true)}</td>
                        <td>{getFormattedAmount(summary.discounted_value, true)}</td>
                        <td>{getFormattedAmount(summary.sales_tax, true)}</td>
                        <td>{getFormattedAmount(summary.further_tax, true)}</td>
                        <td>{getFormattedAmount(summary.wht, true)}</td>
                        <td>{getFormattedAmount(summary.invoice_value, true)}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>

        </LzXPrint>
    );

};

export default SummaryOfSalesInvoicesPrint;
